<template>
  <el-container>
    <el-header style="height: 35px; border-bottom: 1px solid #eee">
      <el-row type="flex" justify="end" align="middle">
        <el-button v-if="permission.emr_mr_repair && readonly" type="warning" icon="el-icon-menu" @click="save" size="mini" plain>保存</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="refresh" plain size="mini">刷新</el-button>
      </el-row>
    </el-header>
    <el-main style="position: absolute; top: 35px; bottom: 0px; left: 0; right: 0; padding: 1rem">
      <el-tabs type="border-card" tab-position="bottom">
        <el-tab-pane label="结构化数据">
          <el-scrollbar style="height: 22rem">
            <p style="text-align: left; white-space: pre-wrap; word-wrap: break-word; padding: 5px 10px 5px 10px">
              {{ docStruct }}
            </p>
          </el-scrollbar>
        </el-tab-pane>
        <el-tab-pane label="全文本">
          <el-input v-if="permission.emr_mr_repair" type="textarea" :rows="16" v-model="txt"></el-input>
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </el-container>
</template>
<script>
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      readonly: Boolean,
    },
    data() {
      return {
        docStruct: "",
        txt: null,
      };
    },
    computed: {
      ...mapGetters(["user", "permission"]),
    },
    mounted() {
      this.$bus.$on("IDE-STRUCT-GENERATED", (docStruct) => {
        this.docStruct = docStruct;
        this.txt = docStruct.allText;
      });
    },
    unmounted() {
      this.$bus.$off("IDE-STRUCT-GENERATED");
    },
    methods: {
      save() {
        if (!this.docStruct) {
          this.$message.error("请先生成结构化数据！");
          return;
        }
        if (!this.docStruct.mainId || !this.docStruct.mrId) {
          this.$message.error("请先选择病历和文书！");
          return;
        }
        // 如果文本被修改了，则在结构化数据中补充修改后的文本
        if (this.txt != this.docStruct.allText) {
          this.docStruct.repairTxt = this.txt;
        }
        this.$api.Struct.repair(this.docStruct).then((res) => {
          this.$message.success("结构化数据已保存！");
        });
      },
      refresh() {
        this.$emit("refresh");
      },
    },
  };
</script>
